// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yq-empty[data-v-25a056d6] {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  overflow: hidden;\n}\n.yq-empty .empty-icon[data-v-25a056d6] {\n  width: 100%;\n  max-width: 4rem;\n}\n.yq-empty .empty-text[data-v-25a056d6] {\n  text-align: center;\n  color: var(--yq-font-color-desc);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
